// extracted by mini-css-extract-plugin
export default {"wrap":"Dots_wrap__SL+Ki","dot":"Dots_dot__PPivf","fade":"Dots_fade__IHy10"};